<template>
    <div class="store-root">
        <div class="content">
            <div class="header">
                <span>{{l10nProductsForTheJewishBookcase}}</span>
            </div>
            <div class="divider"></div>
            <div class="stores-section">
                <div class="printed-books store-section">
                    <div class="store-image">
                        <img src="../assets/images/printed.png" alt="placeholder">
                    </div>
                    <div class="store-content">
                        <div class="store-title">{{l10nPrintedBooks | uppercase}}</div>
                        <div class="store-products">
                            <div class="sidur-card store-product">
                                <div class="product-title">{{l10nSiddur | uppercase}}</div>
                                <div class="product-divider-container">
                                    <div class="product-divider"></div>
                                </div>
                                <div class="product-subtitle">{{l10nASiddurAndTehilimTranslatedIntoSpanish}}</div>
                                <div class="product-actions">
                                    <jabra-btn dark v-on:jbr-click="navigateToSiddurStore()">
                                        <span class="buy-now-span">{{l10nBuyNow}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                            <div class="talmud-card store-product">
                                <div class="product-title">{{l10nTalmud | uppercase}}</div>
                                <div class="product-divider-container">
                                    <div class="product-divider"></div>
                                </div>
                                <div class="product-subtitle">{{l10nTheTalmudIsTranslatedIntoSpanish}}</div>
                                <div class="product-actions">
                                    <jabra-btn dark v-on:jbr-click="navigateToPrintedTalmudStore()">
                                        <span class="buy-now-span">{{l10nBuyNow}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="digital-books store-section">
                    <div class="store-image">
                        <img src="../assets/images/digital.png" alt="placeholder">
                    </div>
                    <div class="store-content">
                        <div class="store-title">{{l10nDigitalBooks | uppercase}}</div>
                        <div class="store-products">
                            <div class="digital-talmud-card store-product">
                                <div class="product-title">TALMUD</div>
                                <div class="product-divider-container">
                                    <div class="product-divider"></div>
                                </div>
                                <div class="product-subtitle">
                                    <span>{{l10nChoosePageMultiplePagesOrMasechetAndDownloadAPdfFileToYourPc}}</span>
                                </div>
                                <div class="product-actions">
                                    <jabra-btn dark v-on:jbr-click="navigateToDigitalTalmudStore()">
                                        <span class="buy-now-span">{{l10nBuyNow}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="bottom-colored-section-container">
            <div class="bottom-colored-section">
            </div>
        </div>
    </div>

</template>

<script>
    import helpers from '../services/helpers'

    export default {
        name: 'store-root-component',
        data: function () {
            return {}
        },
        computed: {
            masechtot() {
                return this.$store.state.masechtot.data
            },
            l10nProductsForTheJewishBookcase() {
                return this.l10nGetter('products_for_the_jewish_bookcase')
            },
            l10nPrintedBooks() {
                return this.l10nGetter('printed_books')
            },
            l10nSiddur() {
                return this.l10nGetter('siddur')
            },
            l10nASiddurAndTehilimTranslatedIntoSpanish() {
                return this.l10nGetter('a_siddur_and_tehilim_translated_into_spanish')
            },
            l10nBuyNow() {
                return this.l10nGetter('buy_now')
            },
            l10nTalmud() {
                return this.l10nGetter('talmud')
            },
            l10nTheTalmudIsTranslatedIntoSpanish() {
                return this.l10nGetter('the_talmud_is_translated_into_spanish')
            },
            l10nDigitalBooks() {
                return this.l10nGetter('digital_books')
            },
            l10nChoosePageMultiplePagesOrMasechetAndDownloadAPdfFileToYourPc() {
                return this.l10nGetter('choose_page_multiple_pages_or_masechet_and_download_a_pdf_file_to_your_pc')
            },
        },
        methods: {
            navigateToPrintedTalmudStore() {
                this.$router.push({name: 'storeTalmud'})
            },
            navigateToSiddurStore() {
                this.$router.push({name: 'storeSiddur'})
            },
            navigateToDigitalTalmudStore() {
                let defaultMasechetId = null
                if (this.masechtot.length > 0) {
                    defaultMasechetId = this.masechtot[0].id
                }
                this.$router.push({name: 'storeDigitalTalmud', params: {masechetId: defaultMasechetId.toString()}})
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 0 130px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .product-divider-container {
        display: flex;
        justify-content: center;

        .product-divider {
            width: 58px;
            height: 8px;
            margin: 10px;
            background: $accent-1;
        }
    }

    .stores-section {
        padding: 10px;
        display: flex;
        justify-content: center;
        max-width: 1400px;

        .store-section {
            border-left: $accent-1 solid 2px;
            box-shadow: 5px 0 10px 0 $grey-2;
            background: white;
        }
        .printed-books {
            margin: 0 26px 0 0;
        }

        .digital-books {
            margin: 0 0 0 26px;
        }
    }

    .store-image {
        img {
            width: 100%;
        }

    }

    .store-title {
        display: flex;
        justify-content: center;
        @include font-abraham(50px, $font-color-blue, 400);
        padding: 30px;
        margin: 0 0 47px 0;
        text-align: center;
    }

    .store-products {
        display: flex;
        justify-content: space-around;
        padding: 13px 0;
    }

    .store-product {
        max-width: 210px;

        &.digital-talmud-card {
            max-width: 300px;
        }
    }

    .product-title {
        display: flex;
        justify-content: center;
        @include font-abraham(36px, $font-color-blue, 400);
    }

    .product-subtitle {
        @include font-abraham(18px, $font-color-blue, 300);
        text-align: center;
        min-height: 64px;
        padding: 15px 0;
    }

    .product-actions {
        display: flex;
        justify-content: center;
        padding: 27px 0;
    }

    .buy-now-span {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
        white-space: nowrap;
    }

    .bottom-colored-section-container {
        z-index: -1;
        position: relative;
    }

    .bottom-colored-section {
        background: rgb(220, 233, 239);
        height: 294px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

</style>
